import { Component } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { DeoZaResenjeZaGo } from './deo-za-resenje-za-go';

@Component({
  selector: 'yt-deo-za-resenje-za-go-inline-update',
  templateUrl: './deo-za-resenje-za-go-inline-update.component.html'
})
export class DeoZaResenjeZaGoInlineUpdateComponent
 extends BaseInlineUpdateComponent<DeoZaResenjeZaGo> {
  constructor(
    protected inlineContainerService: InlineContainerService<DeoZaResenjeZaGo>){
    super(inlineContainerService);
  }
}
